import { render, staticRenderFns } from "./BranchBalanceReportNew.vue?vue&type=template&id=a89bf5cc"
import script from "./BranchBalanceReportNew.vue?vue&type=script&lang=js"
export * from "./BranchBalanceReportNew.vue?vue&type=script&lang=js"
import style0 from "./BranchBalanceReportNew.vue?vue&type=style&index=0&id=a89bf5cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports